<template>
    <div class="page wallet rule">
      <pageTitle title='会员储值优惠政策及使用规则' />
      <div class="item">
        <div>
          <strong>储值优惠政策</strong>
        </div>
        <div>
          2017年12月25日-2018年12月25日期间，充1000元送1000K币+100元电子代金券（5张面额20元）。
        </div>
      </div>
      <div class="item">
        <div>
          <strong>如何充值</strong>
        </div>
        <div>
          登陆官网、APP或官方微信，进入会员中心“我的储值”页面充值，也可在酒店扫描二维码进行充值。
        </div>
      </div>
      <div class="item">
        <div>
          <strong>关于发票</strong>
        </div>
        <div>
          每次消费离店时，由酒店前台现场开发票。
        </div>
      </div>
      <div class="item">
        <div>
          <strong>储值如何使用</strong>
        </div>
        <div>
          （1）&nbsp;会员储值可用于官网、APP、官方微信预订支付，以及商城购物。<br/>
          （2）&nbsp;会员储值不能提现，不能退款。 
        </div>
      </div>
    </div>
</template>

<style lang="less" scoped>
  .page {
    .item {
      display: block;
      background-color: white;
      margin-bottom: 1em;
      color: black;
      div {
        padding: 10px;
      }
    }
    .item div:first-child {
      border-right: 1px solid #f1f1f1;
    }
  }
</style>

<script>
  import pageTitle from "../../components/pageTitle.vue";
  export default {
    data() {
      return {};
    },
    methods: {
      goback(e) {
        e.preventDefault();
        javascript: history.go(-1);
      }
    },
    components: {
      pageTitle
    }
  };
</script>


// WEBPACK FOOTER //
// valueCardRule.vue?3207605d